import { render, staticRenderFns } from "./baidu-map-component.vue?vue&type=template&id=5bf89eff&scoped=true&"
import script from "./baidu-map-component.vue?vue&type=script&lang=js&"
export * from "./baidu-map-component.vue?vue&type=script&lang=js&"
import style0 from "./baidu-map-component.vue?vue&type=style&index=0&id=5bf89eff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf89eff",
  null
  
)

export default component.exports